import { KEY_NAME } from 'src/sessionStorage/getSessionIdInSessionStorage';
import type { SessionId } from 'src/types/Id';

export function setSessionIdInSessionStorage(value: SessionId): void {
    window.sessionStorage.setItem(KEY_NAME, value);
}
